/**
 * If a function is passed, return the function. If no function is passed, return a function that returns null.
 * @param maybeFunction
 * @returns {function(): *}
 * @constructor
 */
export default function CoalesceFunction(maybeFunction) {
    if(typeof maybeFunction === 'function') {
        return maybeFunction;
    }
    else {
        return () => null;
    }
}
